module.exports = __webpack_public_path__ + "img/reqQuesIcon.3771d25b.svg";